module.exports = __webpack_public_path__ + "static/employee_handbook-46e00dfc2c2aeffbf200aa0c8eec534a.png";